import { Component } from '@theme/component';

/** Product clips: native playback, a single playing video and no autoplay. */
class MadoriaMotion extends Component {
  #abort;

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    for (const video of this.querySelectorAll('video')) video.pause();
    super.disconnectedCallback();
  }

  #bind() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    const options = { signal: this.#abort.signal };
    for (const video of this.querySelectorAll('video')) {
      const button = video.parentElement?.querySelector('button');
      if (!(button instanceof HTMLButtonElement)) continue;
      button.hidden = !video.paused;
      video.addEventListener('play', () => {
        for (const other of document.querySelectorAll('madoria-motion-component video')) {
          if (other !== video && other instanceof HTMLVideoElement) other.pause();
        }
        button.hidden = true;
      }, options);
      for (const event of ['pause', 'ended', 'error']) {
        video.addEventListener(event, () => { button.hidden = false; }, options);
      }
    }
  }

  /** @param {MouseEvent} event */
  async playClip(event) {
    if (!(event.target instanceof HTMLButtonElement)) return;
    const video = event.target.parentElement?.querySelector('video');
    if (!(video instanceof HTMLVideoElement)) return;
    try { await video.play(); }
    catch { video.controls = true; video.focus(); }
  }
}

if (!customElements.get('madoria-motion-component')) {
  customElements.define('madoria-motion-component', MadoriaMotion);
}
